// The GTM dataLayer array is declared in src/globals.d.ts so both the app build
// and the spec build see it.

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { LayoutConfigService } from './app/core/_base/layout';
import { DIRECT_REWARDS_DOMAINS, JUSTGO_DOMAINS } from './app/core/_constants/domain-config';
import { miniAppsUrls } from './app/core/_constants/vodapay-miniapp';
import { environment } from './environments/environment';


let layoutConfigService: LayoutConfigService;


// Check browser version
function isNotValidBrowser() {
  if (
    navigator.userAgent.includes('Chrome') && 
    (Number(/Chrome\/([0-9.]+)/.exec(navigator.userAgent)[1].split('.')[0]) < 73)
  ) {
    return true;
  }
  return false;
};
function contains(target, pattern){
  var value = 0;
  pattern.forEach(function(word){
    value = value + target.includes(word);
  });
  return (value === 1)
};
if(isNotValidBrowser()) {
  var body = document.getElementsByTagName("body")[0];
  body.style.textAlign = "center";
  body.style.padding = "30px";
  var img = document.createElement("img");
  img.style.width = "70%";
  img.style.maxWidth = "400px";
  img.style.margin = "10px auto 30px";
  img.setAttribute("src", "https://s3.eu-west-3.amazonaws.com/media.quickbus.com/under-construction.png");
  var h1 = document.createElement("h1");
  h1.style.color = "#0067A9";
  var h1Text = document.createTextNode("Your browser is too old");
  h1.appendChild(h1Text);
  var p = document.createElement("p");
  p.style.marginBottom = "30px";
  var pText = document.createTextNode("Please update your browser to use QuickBus or book via WhatsApp.")
  p.appendChild(pText);
  var a = document.createElement("a");
  a.style.backgroundColor = "#25D366";
  a.style.color = "#FFFFFF";
  a.style.padding = "12px 30px";
  a.style.borderRadius = "4px";
  a.style.maxWidth = "200px";
  a.style.boxShadow = "0px 2px 3px rgba(0,0,0,0.2)";
  a.style.margin = "auto";
  var href = "+27833939942";
  if (contains(window.location.hostname, ["nigeria"])) {
    href = "+2347025001667";
  }
  a.setAttribute("href", "https://api.whatsapp.com/send?text=hi&phone="+href);
  var aText = document.createTextNode("Book on WhatsApp");
  a.appendChild(aText);

  body.appendChild(img);
  body.appendChild(h1);
  body.appendChild(p);
  body.appendChild(a);
} else {
  if (environment.production) {
    enableProdMode();
  }
  
  platformBrowserDynamic().bootstrapModule(AppModule).then(() => {
    const isNotMiniapp = !miniAppsUrls.includes(window.location.hostname);
    //get domain name
    const domainName = window.location.hostname;
    // if domain name is not in miniAppsUrls and is not travelwisemtn.co.za and is not vodapay.quickbus.com
    if ('serviceWorker' in navigator && environment.production && isNotMiniapp && domainName !== 'travelwisemtn.co.za' && domainName !== 'vodapay.quickbus.com' && !JUSTGO_DOMAINS.includes(domainName) && !DIRECT_REWARDS_DOMAINS.includes(domainName)) {
      navigator.serviceWorker.register('/sw-master.js');
    }
  }).catch(err => console.log(err));
};

